import { render, staticRenderFns } from "./bottomFooter.vue?vue&type=template&id=3121e261"
import script from "./bottomFooter.vue?vue&type=script&lang=js"
export * from "./bottomFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports